import store from "@/store";
import { ref, watch, computed } from "@vue/composition-api";

export const useResponsiveAppSidebarVisibility = () => {
  const mqShallShowLeftSidebar = ref(false);
  const mqShallShowRightSidebar = ref(false);
  const mqShallShowRightSidebarCall = ref(false);
  // Close Active Sidebars and other stuff when going in large device
  const currentBreakPoint = computed(
    () => store.getters["app/currentBreakPoint"]
  );
  watch(currentBreakPoint, (val, oldVal) => {
    // Reset chats & contacts left sidebar
    if (oldVal === "md" && val === "lg") {
      mqShallShowLeftSidebar.value = false;
      mqShallShowRightSidebar.value = false;
      mqShallShowRightSidebarCall.value = false;
    }
  });

  return {
    mqShallShowLeftSidebar,
    mqShallShowRightSidebar,
    mqShallShowRightSidebarCall,
  };
};

export const _ = {};
